export enum EventRepeatSchedule {
  Never,
  Daily,
  Weekly,
  Monthly,
  Yearly
}
